import React, { useContext } from 'react';
import { AppContext, ModalContext, EMPTY_OBJECT } from 'commons-ui';
import { UserDetailsContext } from 'context/userDetails';

import LinkAccount from './linkAccount';

export const makeActionHandler = (action: any, params: any) => {
	const { setModalConfig } = useContext(ModalContext);
	const { rowData = EMPTY_OBJECT, isVpa, isBank } = params;
	const { showAlert } = useContext(AppContext);
	const {
		selectedUser: { isBlocked }
	} = useContext(UserDetailsContext);

	switch (action.id) {
		case 'link':
			return () => {
				const bankOrVpa: string = isBank ? 'bank' : 'vpa';
				if (isBlocked === 1) {
					showAlert(`Can not link ${bankOrVpa} account because this user is blocked.`, { type: 'error' });
				} else {
					setModalConfig({
						isOpen: true,
						header: `Link ${bankOrVpa} account`,
						content: <LinkAccount rowData={rowData} isVpa={isVpa} isBank={isBank} />
					});
				}
			};
		default:
			return () => {};
	}
};

export default {
	makeActionHandler
};
